import { render, staticRenderFns } from "./RoutesList.vue?vue&type=template&id=d8c7ff32&scoped=true&"
import script from "./RoutesList.vue?vue&type=script&lang=js&"
export * from "./RoutesList.vue?vue&type=script&lang=js&"
import style0 from "./RoutesList.css?vue&type=style&index=0&id=d8c7ff32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c7ff32",
  null
  
)

export default component.exports